import React, { ReactElement } from "react";
import Link from "next/link";
import styles from "./footer.module.scss";

export const FooterLinkSection = (props: Props): ReactElement => {
  return (
    <div className={styles.footerLinkSection}>
      {props.title && <p className={styles.title}>{props.title}</p>}
      <ul className={styles.list}>
        {props.links.map((link, i) => (
          <li key={i}>
            <Link href={link.slug} locale={link.locale} className={styles.link}>
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

interface Props {
  title?: string;
  links: { label: string; slug: string; locale?: string }[];
}
